module.exports = __webpack_public_path__ + "img/newBen-icon-food.aa2705a5.svg";